import { useEffect } from 'react';
import { useAuth } from '../../lib/auth';
import { setTokenGetter } from '@/lib/api';

/**
 * Bridges Clerk's session token into the plain-fetch API client so that
 * non-React code (loaders, mutations) can attach the Authorization header.
 */
export default function ClerkTokenBridge() {
  const { getToken, isLoaded } = useAuth();

  useEffect(() => {
    if (!isLoaded) return;
    setTokenGetter(() => getToken());
    return () => setTokenGetter(null);
  }, [getToken, isLoaded]);

  return null;
}
